import { Component } from '@angular/core';
import { CommonService, LoaderService } from 'src/app/services';

@Component({
  selector: 'report-preview-loader',
  templateUrl: './report-preview-loader.component.html',
  styleUrls: ['./report-preview-loader.component.scss']
})
export class ReportPreviewLoaderComponent {
  loading: boolean;
  loadingMessage: string = 'Please wait...';

  constructor(
    private loaderService: LoaderService,
    public commonService: CommonService
  ) {
    this.loaderService.reportPreviewLoading.subscribe((v) => {
      this.loading = v.loading;
      this.loadingMessage = v.loadingMessage;
    });
  }
}
